import { Box, MenuItem, TextField, Typography } from "@material-ui/core"
import CharacterCounter from "components/Common/CharacterCounter"
import { useFormikContext } from "formik"
import PropTypes from "prop-types"

import useStyles from "./styles"

const Step1 = () => {
  const classes = useStyles()

  const { values, handleChange, handleBlur, touched, errors, setFieldValue } =
    useFormikContext()

  return (
    <Box>
      <Typography className={classes.label}>Board Name*</Typography>
      <TextField
        type="text"
        name="name"
        id="name"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values?.name}
        style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
        variant="outlined"
        fullWidth
        helperText={touched.name && errors.name}
        error={Boolean(touched.name && errors.name)}
        FormHelperTextProps={{
          className: classes.formHelperText,
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography className={classes.label}>Summary of Function*</Typography>
        <CharacterCounter
          currentValue={values?.summary?.length}
          length={2000}
        />
      </Box>{" "}
      <TextField
        type="text"
        name="summary"
        id="summary"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.summary}
        variant="outlined"
        fullWidth
        multiline
        rows={5}
        style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
        helperText={touched.summary && errors.summary}
        error={Boolean(touched.summary && errors.summary)}
        FormHelperTextProps={{
          className: classes.formHelperText,
        }}
      />
      <Box display="flex" alignItems="flex-end">
        <Box width="25%" className={classes.input}>
          <Typography className={classes.label}>Term Length*</Typography>
          <TextField
            select
            name="term"
            value={values?.term}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            helperText={touched.term && errors.term}
            error={Boolean(touched.term && errors.term)}
            style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          >
            <MenuItem value={"1 year"}>1 year</MenuItem>
            <MenuItem value={"2 years"}>2 years</MenuItem>
            <MenuItem value={"3 years"}>3 years</MenuItem>
            <MenuItem value={"4 years"}>4 years</MenuItem>
            <MenuItem value={"5 years"}>5 years</MenuItem>
            <MenuItem value={"6 years"}>6 years</MenuItem>
            <MenuItem value={"coterminous"}>Coterminous</MenuItem>
            <MenuItem value={"no term limit"}>No term limit</MenuItem>
            <MenuItem value={"other"}>Other</MenuItem>
          </TextField>
        </Box>
        <Box width="25%" className={classes.input}>
          <Typography className={classes.label}>
            Appointing Authority*
          </Typography>
          <TextField
            select
            name="appointing_authority"
            value={values.appointing_authority}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
            helperText={
              touched.appointing_authority && errors.appointing_authority
            }
            error={Boolean(
              touched.appointing_authority && errors.appointing_authority
            )}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          >
            <MenuItem value={"council"}>Council</MenuItem>
            <MenuItem value={"governor"}>Governor</MenuItem>
            <MenuItem value={"outside organizations"}>
              Outside Organizations
            </MenuItem>
            <MenuItem value={"board/commission members"}>
              Board/Commission Members
            </MenuItem>
            <MenuItem value={"legislative delegation"}>
              Legislative Delegation
            </MenuItem>
            <MenuItem value={"other"}>Other</MenuItem>
          </TextField>
        </Box>

        <Box width="50%">
          <Typography className={classes.label}>
            Enabling Legislation
          </Typography>
          <TextField
            type="text"
            name="enabling_legislation"
            id="enabling_legislation"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Paste here"
            value={values.enabling_legislation}
            variant="outlined"
            fullWidth
            style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
            helperText={
              touched.enabling_legislation && errors.enabling_legislation
            }
            error={Boolean(
              touched.enabling_legislation && errors.enabling_legislation
            )}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          />
        </Box>
      </Box>
      <Box display="flex" alignItems="flex end">
        <Box width="25%" className={classes.input}>
          <Typography className={classes.label}>Re-Appointment*</Typography>
          <TextField
            select
            value={values.reappointment}
            onChange={(e) => setFieldValue("reappointment", e.target.value)}
            variant="outlined"
            fullWidth
            style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
            helperText={touched.reappointment && errors.reappointment}
            error={Boolean(touched.reappointment && errors.reappointment)}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          >
            <MenuItem value={"not permitted"}>Not Permitted</MenuItem>
            <MenuItem value={"2 terms"}>2 Terms</MenuItem>
            <MenuItem value={"3 terms"}>3 Terms</MenuItem>
            <MenuItem value={"4 terms"}>4 Terms</MenuItem>
            <MenuItem value={"5 terms"}>5 Terms</MenuItem>
            <MenuItem value={"no limits"}>No Limits</MenuItem>
          </TextField>
        </Box>
        <Box width="25%" className={classes.input}>
          <Typography className={classes.label}>Type of App*</Typography>
          <TextField
            select
            value={values.app_type}
            onChange={(e) => setFieldValue("app_type", e.target.value)}
            variant="outlined"
            fullWidth
            style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
            helperText={touched.app_type && errors.app_type}
            error={Boolean(touched.app_type && errors.app_type)}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          >
            <MenuItem value={"open"}>Open</MenuItem>
            <MenuItem value={"invite only"}>Invite Only</MenuItem>
          </TextField>
        </Box>
        <Box width="50%">
          <Typography className={classes.label}>Board Url</Typography>
          <TextField
            type="text"
            name="board_url"
            id="boardUrl"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.board_url}
            variant="outlined"
            fullWidth
            placeholder="Paste here"
            style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
            helperText={touched.board_url && errors.board_url}
            error={touched.board_url && errors.board_url}
            FormHelperTextProps={{
              className: classes.formHelperText,
            }}
          />
        </Box>
      </Box>
      <Box width="50%">
        <Typography className={classes.label}>Meeting Minutes</Typography>
        <TextField
          type="text"
          name="minutes_url"
          id="minutesUrl"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.minutes_url}
          style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
          variant="outlined"
          fullWidth
          placeholder="Paste here"
          helperText={touched.minutes_url && errors.minutes_url}
          error={Boolean(touched.minutes_url && errors.minutes_url)}
          FormHelperTextProps={{
            className: classes.formHelperText,
          }}
        />
      </Box>
    </Box>
  )
}
Step1.propTypes = {
  values: PropTypes.object,
}
export default Step1
